import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import './navigating.css'
import { getUserData } from '../../redux/actions/login'
import Loader from '../../components/global/Loader'
import { useEffect } from 'react'
import { globalKeyStore } from '../../redux/actions/globalState'
import { EMPTY_OBJECT } from '../../constants/globalConstants'

function Navigating(props) {
    const { acc, ref, partner, masquerade } = useParams()
    const { dispatch, isFetching, partnerDetails } = props
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const userData = {}
        if ((acc && acc != 0) && (ref && ref != 0)) {
            userData.access_token = acc
            userData.refresh_token = ref
        }

        localStorage.setItem('userData', JSON.stringify(userData))

        if (masquerade && masquerade != '') {
            localStorage.setItem('masquerade', masquerade)
        } else {
            localStorage.removeItem('masquerade')
        }
    }, [])

    useEffect(() => {
        if (partner) {
            setLoading(true)
            localStorage.setItem('partnerData', JSON.stringify(partnerDetails))
            if ((acc && acc != 0) && (ref && ref != 0)) {
                localStorage.setItem('isLoggedIn', true)
                dispatch(globalKeyStore({ isLoading: false, isLoginModal: false, isLoggedIn: true }))
                dispatch(getUserData()).then((res) => {
                    if (res?.email) {
                        dispatch(globalKeyStore({ userDetails: res }))
                        setLoading(false)
                        const userProfileData = JSON.parse(localStorage.getItem('userData'))
                        userProfileData.user = res
                        if (userProfileData) {
                            localStorage.setItem('userData', JSON.stringify(userProfileData))
                            navigate(`/${partnerDetails?.slug ? partnerDetails?.slug : partner}`)
                        } else {
                            localStorage.setItem('userData', '{}')
                        }
                    } else {
                        dispatch(globalKeyStore({ userDetails: {} }))
                        navigate(`/${partnerDetails?.slug ? partnerDetails?.slug : partner}`)
                        localStorage.removeItem('userData')
                    }
                }).catch(() => {
                    dispatch(globalKeyStore({ userDetails: {} }))
                    navigate(`/${partnerDetails?.slug ? partnerDetails?.slug : partner}`)
                    localStorage.removeItem('userData')
                })
            } else {
                navigate(`/${partnerDetails?.slug ? partnerDetails?.slug : partner}`)
                localStorage.setItem('isLoggedIn', false)
            }
        } else {
            localStorage.removeItem('partnerSecret')
            localStorage.removeItem('partnerData')
            localStorage.removeItem('masquerade')
            navigate('/')
        }
    }, [partner, acc, ref, partnerDetails, dispatch])

    return (
        <div className="d-flex justify-content-center align-items-center loaderDivHeight">
            {isFetching || loading && <Loader
                eventsLoader={true}
            />}
        </div>
    )
}

Navigating.propTypes = {
    dispatch: PropTypes.func,
    isFetching: PropTypes.bool,
    partnerDetails: PropTypes.object,
}

Navigating.defaulProps = {
    dispatch: noop,
    isFetching: true,
    partnerDetails: EMPTY_OBJECT,
}

function mapStateToProps({
    globalReducers
}) {
    return {
        isFetching: globalReducers?.loader,
        partnerDetails: globalReducers?.partnerDetails

    }
}
export default connect(mapStateToProps)(Navigating)